import { render, staticRenderFns } from "./Detail-Quotation.vue?vue&type=template&id=9d83e004&"
import script from "./Detail-Quotation.vue?vue&type=script&lang=js&"
export * from "./Detail-Quotation.vue?vue&type=script&lang=js&"
import style0 from "./Detail-Quotation.vue?vue&type=style&index=0&id=9d83e004&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports